import { render, staticRenderFns } from "./RightBarSettings.vue?vue&type=template&id=8a1b5be2&scoped=true&"
import script from "./RightBarSettings.vue?vue&type=script&lang=js&"
export * from "./RightBarSettings.vue?vue&type=script&lang=js&"
import style0 from "./RightBarSettings.vue?vue&type=style&index=0&id=8a1b5be2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a1b5be2",
  null
  
)

export default component.exports